import React, { useEffect, useState } from 'react';
import './Card.module.scss';
import { useHistory, useParams } from 'react-router-dom';

// Import types
import { Block } from '../Grid';
import TitleAndDescription from './Layouts/TitleAndDescription/TitleAndDescription';
import TitleAndImages from './Layouts/TitleAndImages/TitleAndImages';
import TitleAndImage from './Layouts/TitleAndImage/TitleAndImage';
import Title from './Layouts/Title/Title';
import Quote from './Layouts/Quote/Quote';
import ArticleModal from './ArticleModal/ArticleModal';

type Props = {
  item: Block;
  index: number;
};

export default function Card({ item, index }: Props) {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const [mountCounter, setMountCounter] = useState(0);

  const lowTile = item?.column_width == 2 && item?.row_height == 1;

  const { id } = useParams() as {
    id: string;
    url: string;
  };

  useEffect(() => {
    if (mountCounter === 0) {
      setMountCounter(1);
    }
  }, []);

  // this useEffect runs when props.open changes and then locks or unlocks the body from overflowing
  useEffect(() => {
    if (modalOpen === true) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
      if (mountCounter !== 0) {
        history.push('/');
      }
    }
  }, [modalOpen]);

  // open modal if url had id inside it
  useEffect(() => {
    if (item?.id == parseInt(id)) {
      setModalOpen(true);
    }
  }, [id]);

  return (
    <>
      <div
        onClick={() => {
          history.push(`/${item.id}`);
        }}
        style={{
          gridColumn: `span ${item?.column_width}`,
          gridRow: `span ${item?.row_height}`,
          background: `${item.background}`,
          // background: `${item.backgroundPattern}`,
        }}
        styleName={`item ${lowTile ? 'low-tile' : ''}`}
      >
        {(() => {
          const content = item?.block_layout?.[0];
          switch (content?.layout) {
            case 'title_and_image':
              return (
                <TitleAndImage
                  lowTile={lowTile}
                  attributes={content?.attributes}
                />
              );
            case 'title_and_images':
              return <TitleAndImages attributes={content?.attributes} />;
            case 'title_and_description':
              return <TitleAndDescription attributes={content?.attributes} />;
            case 'title':
              return <Title attributes={content?.attributes} />;
            case 'quote':
              return <Quote attributes={content?.attributes} />;
            default:
              return <p>default</p>;
          }
        })()}
        <p styleName="source">{item?.source}</p>
        <div
          style={{
            background: `${item.background}`,
          }}
          styleName="hover-overlay"
        >
          <div styleName="inner">
            <div
              style={{
                backgroundImage: `linear-gradient(transparent, ${item.background})`,
              }}
              styleName="transition-div"
            />
            <h3>Meer achtergrondinformatie</h3>
          </div>
        </div>
      </div>
      {modalOpen && (
        <ArticleModal
          item={item}
          modalIsOpen={modalOpen}
          setModalIsOpen={setModalOpen}
        />
      )}
    </>
  );
}
